import {
    createStyles,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogTitleProps,
    IconButton,
    StandardProps,
    Theme,
    Typography
} from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { CreativePreview, CreativePreviewProps } from "./CreativePreview";
import { StyleClassKey } from "js/react/typescript";
import React from "react";
import { Close as CloseIcon } from "@material-ui/icons";

export interface CreativePreviewDialogProps extends CreativePreviewProps {
    onClose: () => void;
    title: string;
}

const titleStyles = (theme: Theme) =>
    createStyles({
        root: {
            margin: 0,
            maxHeight: 600,
            padding: theme.spacing(2)
        },
        closeButton: {
            position: "absolute",
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500]
        }
    });

interface StepWizardDialogTitleProps
    extends StandardProps<DialogTitleProps, StyleClassKey<typeof titleStyles>> {
    onClose: () => void;
}

const StepWizardDialogTitle = withStyles(titleStyles)(
    (props: StepWizardDialogTitleProps) => {
        const { children, classes, onClose, ...other } = props;
        return (
            <DialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={onClose}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
        );
    }
);

const StepWizardDialogContent = withStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(2)
    }
}))(DialogContent);

export const CreativePreviewDialog = (props: CreativePreviewDialogProps) => {
    return (
        <Dialog open maxWidth={"md"}>
            <StepWizardDialogTitle onClose={props.onClose}>
                {props.title}
            </StepWizardDialogTitle>
            <StepWizardDialogContent dividers>
                <CreativePreview content={props.content} />
            </StepWizardDialogContent>
        </Dialog>
    );
};
